import React, { useEffect, useState } from 'react';
import { Checkbox } from 'primereact/checkbox';
import DateTextInput from 'app/component/date-text-input'; // Mock enum values (replace with your actual enum values)

// Mock enum values (replace with your actual enum values)
const agentExamEducationTypes = [
  'EXAM_POISTENIE_ZAISTENIE',
  'EXAM_KAPITALOVY_TRH',
  'EXAM_UVERY',
  'EXAM_VKLADY',
  'EXAM_DDS',
  'EXAM_SDS',
  'EDUCATION_POISTENIE_ZAISTENIE',
  'EDUCATION_KAPITALOVY_TRH',
  'EDUCATION_UVERY',
  'EDUCATION_VKLADY',
  'EDUCATION_DDS',
  'EDUCATION_SDS',
  'GDPR',
  'AML'
];

const AgentExamEducationPanel = ({ agent, existingEducations, onEducationChange }) => {
  const [agentEducations, setAgentEducations] = useState([]);

  useEffect(() => {
    // Initialize the state with all possible education types
    const initialEducations = agentExamEducationTypes.map(type => ({
      examEducationType: type,
      hasNBS: false,
      validFrom: null,
      validTo: null,
      nbsRegistrationDate: null,
    }));

    // Merge existing educations if provided
    if (existingEducations && existingEducations.length > 0) {
      const mergedEducations = initialEducations.map(initialEdu => {
        const existingEdu = existingEducations.find(edu => edu.examEducationType === initialEdu.examEducationType);
        return existingEdu ? { ...initialEdu, ...existingEdu } : initialEdu;
      });
      setAgentEducations(mergedEducations);
    } else {
      setAgentEducations(initialEducations);
    }
  }, [agent, existingEducations]);

  const handleEducationChange = (index, field, value) => {
    const updatedEducations = [...agentEducations];
    updatedEducations[index][field] = value;
    setAgentEducations(updatedEducations);
    if (onEducationChange) {
      // Optional: Callback to inform the parent component about changes
      onEducationChange(updatedEducations);
    }
  };

  const getTypeName = v => {
    if (v === 'EXAM_POISTENIE_ZAISTENIE') {
      return 'Skúška: Poistenie alebo zaistenie';
    } else if (v === 'EXAM_KAPITALOVY_TRH') {
      return 'Skúška: Kapitálový trh';
    } else if (v === 'EXAM_UVERY') {
      return 'Skúška: Úvery';
    } else if (v === 'EXAM_VKLADY') {
      return 'Skúška: Vklady';
    } else if (v === 'EXAM_DDS') {
      return 'Skúška: DDS';
    } else if (v === 'EXAM_SDS') {
      return 'Skúška: SDS';
    } else if (v === 'EDUCATION_POISTENIE_ZAISTENIE') {
      return 'Vzdelávanie: Poistenie alebo zaistenie';
    } else if (v === 'EDUCATION_KAPITALOVY_TRH') {
      return 'Vzdelávanie: Kapitálový trh';
    } else if (v === 'EDUCATION_UVERY') {
      return 'Vzdelávanie: Úvery';
    } else if (v === 'EDUCATION_VKLADY') {
      return 'Vzdelávanie: Vklady';
    } else if (v === 'EDUCATION_DDS') {
      return 'Vzdelávanie: DDS';
    } else if (v === 'EDUCATION_SDS') {
      return 'Vzdelávanie: SDS';
    } else if (v === 'GDPR') {
      return 'GDPR';
    } else if (v === 'AML') {
      return 'AML';
    }

    return v;
  };

  const typesWithNBS = ['EXAM_POISTENIE_ZAISTENIE', 'EXAM_KAPITALOVY_TRH', 'EXAM_UVERY', 'EXAM_VKLADY', 'EXAM_DDS', 'EXAM_SDS'];

  return (
    <div>
      {agentEducations.map((education, index) => (
        <div key={index} className="grid">
          <div className="col-12 md:col-3" style={{ marginTop: '30px' }}>
            <label htmlFor={`educationType-${index}`}>{getTypeName(education.examEducationType)}</label>
          </div>
          <div className="col-12 md:col-2">
            <label htmlFor={`validFrom-${index}`}>Platné od</label>
            <DateTextInput
              id={`validFrom-${index}`}
              value={education.validFrom}
              onChange={val => handleEducationChange(index, 'validFrom', val)}
            />
          </div>
          <div className="col-12 md:col-2">
            <label htmlFor={`validTo-${index}`}>Platné do</label>
            <DateTextInput
              id={`validTo-${index}`}
              value={education.validTo}
              onChange={val => handleEducationChange(index, 'validTo', val)}
            />
          </div>
          <div className="col-12 md:col-3">
            {typesWithNBS.includes(education.examEducationType) && (
              <>
                <label htmlFor={`nbsRegistrationDate-${index}`}>Dátum registrácie do NBS</label>
                <DateTextInput
                  id={`nbsRegistrationDate-${index}`}
                  value={education.nbsRegistrationDate}
                  onChange={val => handleEducationChange(index, 'nbsRegistrationDate', val)}
                />
              </>
            )}
          </div>
          <div className="col-12 md:col-2">
            {typesWithNBS.includes(education.examEducationType) && (
              <div className="field-checkbox" style={{ marginTop: '30px' }}>
                <Checkbox
                  inputId={`hasNBS-${index}`}
                  checked={education.hasNBS || false}
                  onChange={e => handleEducationChange(index, 'hasNBS', e.checked)}
                />
                <label htmlFor={`hasNBS-${index}`}>NBS</label>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AgentExamEducationPanel;
